import { render, staticRenderFns } from "./footer-toolbar.vue?vue&type=template&id=37f8099e"
import script from "./footer-toolbar.vue?vue&type=script&lang=js"
export * from "./footer-toolbar.vue?vue&type=script&lang=js"
import style0 from "./footer-toolbar.vue?vue&type=style&index=0&id=37f8099e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports